<template lang="html">
    <div id="splashMini" ref="splashMini" v-if="run">

        <div class="logo loading" id="logo" ref="logo">
            <div id="imageSeparator" style="display: flex;align-items: center;align-content: center; padding: 0;width: 50%;margin:0;" >
                <img class="logoImg" :src="a1" alt="">
            </div>
            <div ref="message" id="message" style="display: flex;justify-content: flex-start;align-items: center;align-content: flex-end; padding: 0;">
                <span>Bienvenido</span>
            </div>
        </div>

        <div class="circleMini delay1"></div>   
        <div class="circleMini delay2"></div>
        <div class="circleMini delay3"></div>
        <div class="circleMini delay4"></div>

    </div>
</template>
<script>
export default {
    name:"simpleSplash",
    props:{
        welcome:{
            default:false,
            type: Boolean
        },
        time:{
            default:1000,
            type: Number
        },
        stop:{
            default:0,
            type:Number
        }
    },
    watch:{
        stop(){
            this.stopSplash();
        }
    },
    data(){
        return{
            run:true,
            a1:require('@/assets/images/a1.png'),
        }
    },
    mounted(){
        setTimeout(()=>{
            if(this.welcome){
                this.stopSplash();
            }else{
                this.run = false;
            }
        }, this.time)
    },
    methods:{
        stopSplash(){
            this.$refs.splashMini.querySelectorAll('.circleMini').forEach(item => {
                item.classList.add('d-none');
            })
            this.$refs.logo.classList.remove('loading');
            this.$refs.message.style.width = '50%';
            setTimeout(()=>{
                this.run = false;
            }, 1500)
        }
    }
}
</script>
<style lang="css" scoped>
#splashMini {
    width: 100vw;
    height: 100vh;
    position: fixed;
    margin: 0;
    padding: 0;
    display: flex;
    justify-content: center;
    align-content: center;
    align-items: center;
    background-color: #444;
    overflow: hidden;
    z-index: 4003;
    user-select: none;
    -moz-user-select: none;
    -webkit-user-select: none;
    -ms-user-select: none;
}

#splashMini .delay1 {
    -webkit-animation: waves 2.5s linear infinite;
    animation: waves 2.5s linear infinite;
    -webkit-animation-delay: 0.1s;
    animation-delay: 0.1s;
}

#splashMini:hover .delay2 {
    -webkit-animation: waves 2.5s linear 0.7s infinite;
    animation: waves 2.5s linear 0.7s infinite;
}

#splashMini.delay3 {
    -webkit-animation: waves 2.5s linear 1.3s infinite;
    animation: waves 2.5s linear 1.3s infinite;
}

#splashMini .delay4 {
    -webkit-animation: waves 2.5s linear 1.9s infinite;
    animation: waves 2.5s linear 1.9s infinite;
}

#splashMini .loading {
    -webkit-animation: bloop 1s linear infinite;
    animation: bloop 1s linear infinite;
}

@keyframes waves {
    0% {
        transform: scale(1);
        opacity: 1;
    }

    100% {
        transform: scale(4);
        opacity: 0;
    }
}

@-webkit-keyframes bloop {
    0% {
        transform: scale3d(1, 1, 1);
    }

    30% {
        transform: scale3d(1.25, 0.75, 1);
    }

    40% {
        transform: scale3d(0.75, 1.25, 1);
    }

    50% {
        transform: scale3d(1.15, 0.85, 1);
    }

    65% {
        transform: scale3d(0.95, 1.05, 1);
    }

    75% {
        transform: scale3d(1.05, 0.95, 1);
    }

    100% {
        transform: scale3d(1, 1, 1);
    }
}

@keyframes bloop {
    0% {
        transform: scale3d(1, 1, 1);
    }

    30% {
        transform: scale3d(1.25, 0.75, 1);
    }

    40% {
        transform: scale3d(0.75, 1.25, 1);
    }

    50% {
        transform: scale3d(1.15, 0.85, 1);
    }

    65% {
        transform: scale3d(0.95, 1.05, 1);
    }

    75% {
        transform: scale3d(1.05, 0.95, 1);
    }

    100% {
        transform: scale3d(1, 1, 1);
    }
}

#splashMini .logo {
    position: absolute;
    z-index: 10;
    border-radius: 50%;
    height: 80px;
    width: 450px;
    display: flex;
    z-index: 100;
    justify-content: center;
    transition: all 0.7s;
    margin-left: 0;
    margin-right: 0;
    margin-bottom: 60px;
}

#splashMini .logoImg {
    height: 100%;
    object-fit: cover;
    overflow: visible !important;
}

#splashMini #imageSeparator {
    justify-content: flex-end;
}

#splashMini .loading #imageSeparator {
    justify-content: center !important;
}

#splashMini .loading #message {
    margin: 0 !important;
}

#splashMini #message {
    transition: all 0.7s;
    width: 0px;
    margin: 0 15px 0 15px;
    overflow: hidden;
    font-family: Arial, Helvetica, sans-serif;
}

#splashMini #message span {
    position: relative;
    font-size: 36px;
    color: #fff;
    font-weight: bold;
    transition: all 0.7s;
}

#splashMini .circleMini {
    display: flex;
    height: 90px;
    width: 90px;
    border-radius: 50%;
    background: #0194c7;
    margin: 10px 0 60px 0;
    transition: 5s ease;
    position: absolute;
}

</style>